export default __webpack_public_path__ + "static/media/KBM04562.5a854f1e.webp";